import { useEffect } from 'react';

/**
 * با کلیک بیرون از ناحیه ویرایش فعال، callback را فراخوانی می‌کند.
 */
export function useClickOutsideWhen(active, onOutside, containerRef) {
  useEffect(() => {
    if (!active) return undefined;

    const handlePointerDown = (event) => {
      const root = containerRef?.current;
      if (!root) return;
      if (root.contains(event.target)) return;
      // dropdown/select پورتال ant — داخل ویرایش inline حساب شود
      if (event.target.closest('.ant-select-dropdown, .ant-picker-dropdown, .rmdp-wrapper, .rmdp-container')) {
        return;
      }
      onOutside?.();
    };

    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('touchstart', handlePointerDown);
    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('touchstart', handlePointerDown);
    };
  }, [active, onOutside, containerRef]);
}
